<template>
  <div class="custom-w">
    <div style="padding-left: 12px">
      <el-row class="title" type="flex">
        <div class="shape"></div>
        <div>
          <span class="text">国内常用版本</span>
        </div>
      </el-row>
      <span class="sub-title">Domestic Common Version</span>
    </div>
    <CommonRelease
      :url="`/package/release/?is_common=true&area=China`"
      :color="`#265CFD`"
      :isCN="true"
      :codes4HideDetail="commonHideCodes"
    />
    <div style="padding: 64px 0 0 12px">
      <el-row class="title" type="flex">
        <div class="shape"></div>
        <div>
          <span class="text">国内其他版本</span>
        </div>
      </el-row>
      <span class="sub-title">Domestic Other Version</span>
    </div>
    <UncommonRelease
      :url="`/package/release/?is_common=false&area=China`"
      :color="`#265CFD`"
      :isCN="true"
      :codes4HideDetail="uncommonHideCodes"
    />
  </div>
</template>

<script>
import CommonRelease from "@/views/common/commonRelease";
import UncommonRelease from "@/views/common/uncommonRelease";

export default {
  name: "Home",
  components: { CommonRelease, UncommonRelease },
  data() {
    return {
      dense: false,
      loading: true,
      selection: 1,
      commonHideCodes: ['onmoblieios'],
      uncommonHideCodes: ['remoteservermac', 'remoteclientmac-manual'],
    };
  },
  methods: {
    reserve() {
      this.loading = true;
      setTimeout(() => (this.loading = false), 2000);
    },
  },
  computed: {
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
.title {
  height: 42px;

  .shape {
    height: 28px;
    width: 8px;
    border-radius: 2px;
    background: #265CFD;
    margin-top: 7px;
  }

  .text {
    font-size: 30px;
    color: #111111;
    margin-left: 12px;
    font-weight: bold;
  }
}

</style>
